var render = function () {
  var _vm$professor, _vm$professor2, _vm$professor3, _vm$professor4, _vm$professor5;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('b-row', [_c('b-col', [_c('b-card', {
    staticClass: "header-marcar_consulta bg-gradient-primary"
  }, [_c('b-row', {
    attrs: {
      "align-v": "center"
    }
  }, [_c('b-col', {
    attrs: {
      "lg": "6"
    }
  }, [_c('h1', [_c('feather-icon', {
    staticClass: "mr-50",
    attrs: {
      "icon": "UsersIcon",
      "size": "30"
    }
  }), _vm._v(" Turmas do Professor: " + _vm._s((_vm$professor = _vm.professor) === null || _vm$professor === void 0 ? void 0 : _vm$professor.fullName) + " ")], 1)]), _c('b-col', {
    attrs: {
      "lg": "3"
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "secondary"
    },
    on: {
      "click": function click($event) {
        return _vm.$router.go(-1);
      }
    }
  }, [_c('feather-icon', {
    staticClass: "mr-50",
    attrs: {
      "icon": "ArrowLeftIcon",
      "size": "16"
    }
  }), _vm._v(" Voltar ")], 1)], 1), _c('b-col', {
    attrs: {
      "lg": "3"
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "primary button-right"
    },
    on: {
      "click": _vm.vincularTurma
    }
  }, [_c('feather-icon', {
    staticClass: "mr-50",
    attrs: {
      "icon": "PlusIcon",
      "size": "16"
    }
  }), _vm._v(" Vincular Turma ")], 1)], 1)], 1)], 1)], 1)], 1), _c('b-card', {
    staticClass: "mb-2"
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('h6', [_vm._v("Informações do Professor")]), _c('p', [_c('strong', [_vm._v("Nome:")]), _vm._v(" " + _vm._s((_vm$professor2 = _vm.professor) === null || _vm$professor2 === void 0 ? void 0 : _vm$professor2.fullName))]), _c('p', [_c('strong', [_vm._v("Email:")]), _vm._v(" " + _vm._s((_vm$professor3 = _vm.professor) === null || _vm$professor3 === void 0 ? void 0 : _vm$professor3.email))]), _c('p', [_c('strong', [_vm._v("Disciplina:")]), _vm._v(" " + _vm._s((_vm$professor4 = _vm.professor) === null || _vm$professor4 === void 0 ? void 0 : _vm$professor4.discipline))])]), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('h6', [_vm._v("Escolas")]), _vm.escolasDistinct && _vm.escolasDistinct.length > 0 ? _c('div', _vm._l(_vm.escolasDistinct, function (escola) {
    return _c('b-badge', {
      key: escola,
      staticClass: "mr-1 mb-1",
      attrs: {
        "variant": "info"
      }
    }, [_vm._v(" " + _vm._s(escola) + " ")]);
  }), 1) : _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("Nenhuma escola vinculada")])])], 1)], 1), _c('b-card', {
    staticClass: "mb-0",
    attrs: {
      "no-body": ""
    }
  }, [_c('b-card-header', [_c('h5', [_vm._v("Turmas Vinculadas")])]), _c('b-table', {
    ref: "refTurmasTable",
    staticClass: "position-relative",
    staticStyle: {
      "min-height": "50vw"
    },
    attrs: {
      "items": ((_vm$professor5 = _vm.professor) === null || _vm$professor5 === void 0 ? void 0 : _vm$professor5.turmas) || [],
      "responsive": "",
      "fields": _vm.tableColumns,
      "primary-key": "id",
      "show-empty": "",
      "empty-text": "Nenhuma turma vinculada a este professor"
    },
    scopedSlots: _vm._u([{
      key: "cell(index)",
      fn: function fn(data) {
        return [_vm._v(" " + _vm._s(data.index + 1) + " ")];
      }
    }, {
      key: "cell(actions)",
      fn: function fn(data) {
        return [_c('b-button', {
          attrs: {
            "variant": "outline-danger",
            "size": "sm"
          },
          on: {
            "click": function click($event) {
              return _vm.desvincularTurma(data.item);
            }
          }
        }, [_c('feather-icon', {
          attrs: {
            "icon": "XIcon",
            "size": "14"
          }
        }), _vm._v(" Desvincular ")], 1)];
      }
    }])
  })], 1), _c('b-modal', {
    staticStyle: {
      "height": "400px"
    },
    attrs: {
      "id": "modal-vincular-turma",
      "title": "Vincular Nova Turma",
      "size": "lg",
      "scrollable": "",
      "ok-title": "Vincular",
      "cancel-title": "Cancelar"
    },
    on: {
      "ok": _vm.confirmarVinculacao,
      "hidden": _vm.resetVinculacaoForm
    }
  }, [_c('b-form', {
    on: {
      "submit": function submit($event) {
        $event.preventDefault();
        return _vm.confirmarVinculacao.apply(null, arguments);
      }
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Escola",
      "label-for": "v-school"
    }
  }, [_c('v-select', {
    attrs: {
      "id": "school",
      "dir": _vm.$store.state.appConfig.isRTL ? 'rtl' : 'ltr',
      "options": _vm.schoolOptions,
      "value": "id",
      "label": "name",
      "placeholder": "Selecione uma escola"
    },
    on: {
      "input": _vm.onSchoolChange
    },
    model: {
      value: _vm.vinculacaoForm.schoolId,
      callback: function callback($$v) {
        _vm.$set(_vm.vinculacaoForm, "schoolId", $$v);
      },
      expression: "vinculacaoForm.schoolId"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Turma",
      "label-for": "v-classroom"
    }
  }, [_c('v-select', {
    attrs: {
      "id": "classroom",
      "dir": _vm.$store.state.appConfig.isRTL ? 'rtl' : 'ltr',
      "options": _vm.classroomOptions,
      "value": "id",
      "label": "name",
      "placeholder": "Selecione uma turma",
      "disabled": !_vm.vinculacaoForm.schoolId
    },
    model: {
      value: _vm.vinculacaoForm.classroomId,
      callback: function callback($$v) {
        _vm.$set(_vm.vinculacaoForm, "classroomId", $$v);
      },
      expression: "vinculacaoForm.classroomId"
    }
  })], 1)], 1)], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }